function reducer(state = [], action) {    
    switch (action.type) {
        case 'COLORS/SET':
            return action.colors;
        case 'COLORS/CLEAR':
            return null;        
        default:
            return state;
    }
}

export default reducer;
